
<label style="text-align: center;">Query Reference Number - <span class="referanceNumber"> {{queryReferenceNumber}} </span></label>
<br/>
<nz-table [nzSize]="'small'" [nzData]="fileAttachments" [nzBordered]="true" [nzSize]="'small'" [nzShowPagination]="false" aria-describedby="row">
    <thead>
      <tr>
        <th scope="col" title="Select files to download" style="width: 120px;">Download
          <input *ngIf="fileAttachments.length > 0" type="checkbox" name="SelectAll" (change)="selectAllFiles()"
            [(ngModel)]="SelectAll" />
        </th>
        <th class="thead text-center">File Name</th>
        <th class="thead text-center">Uploaded By</th>
        <th class="thead text-center" style="width: 150px;">Uploaded Date</th>
        <!-- <th class="thead text-center">Action</th> -->
      </tr>
    </thead>
    <tbody *ngIf="fileAttachments.length > 0">
      <tr *ngFor="let file of fileAttachments">
        <td style="text-align: center">
          <input type="checkbox" (change)="resetSelectAll()" name="Select" [(ngModel)]="file.Select" />
        </td>
        <td class="text-center"><strong>{{file.File_Name}}</strong></td>
        <td class="text-center">{{file.Uploaded_By}}</td>
        <td class="text-center">{{file.Uploaded_Date | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
        <!-- <td class="text-center">
          <a (click)="downloadFile(file.File_Name)">
            <i class="fa fa-times" aria-hidden="true">
              download</i></a>
        </td> -->
      </tr>
    </tbody>
    <tbody *ngIf="fileAttachments.length == 0">
      <tr style="display: none;">
        <td colspan="4" class="text-center">
          No attachments found
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div nz-row>
    <div nz-col nzSpan="6">      
      <button nz-button nzType="primary" (click)="downloadFiles()" [disabled]="fileAttachments.length == 0">
         Download
    </button>
    </div>
    <div nz-col nzSpan="16" *ngIf="displayErrMsg">
        <div class="text-danger">{{errorMsg}}</div>
    </div>
  </div>